const fa = {
    login: "ورود",
    logout: "خروج",
    signIn: "وارد شوید",
    signOut: "خروج",
    profile: "پروفایل",
    settings: "تنظیمات",
    digiAirMenuWaiterLogin: "ورود گارسون DigiAirMenu",
    appLogoAlt: "لوگوی digiAirMenu",
    username: "نام کاربری",
    password: "رمز عبور",
    pinCode: "کد PIN",
    yourAuthenticationFailed: "احراز هویت ناموفق بود",
    addDAMToHomeScreen: "DigiAirMenu را به صفحه اصلی اضافه کنید",
    addToHomeScreen: "افزودن به صفحه اصلی",
    installDAM: "نصب DAM",
    language: "زبان",
    chooseLanguage: "انتخاب زبان",
    pageNotFound: "صفحه پیدا نشد",
    backToDashboard: "بازگشت به داشبورد",
    transferToDemo: "انتقال به حالت دمو",
    transferToLive: "انتقال به حالت زنده",
    currentTable: "میز فعلی",
    table: "میز",
    tables: "میزها",
    order: "سفارش",
    orders: "سفارش‌ها",
    option: "گزینه",
    additive: "افزودنی",
    options: "گزینه‌ها",
    additives: "افزودنی‌ها",
    empty: "خالی",
    row: "ردیف",
    count: "تعداد",
    step: "مرحله",
    title: "عنوان",
    untitledItem: "بدون عنوان",
    createdAt: "ایجاد شده در",
    free: "رایگان",
    freeItems: "آیتم‌های رایگان",
    items: "آیتم‌ها",
    item: "آیتم",
    itemsCountOfAll: "{{payCount}} از {{maxCount}}",
    minimum: "حداقل",
    maximum: "حداکثر",
    min: "حداقل",
    max: "حداکثر",
    all: "همه",
    unitPrice: "قیمت واحد",
    email: "ایمیل",
    print: "چاپ",
    printingFailed: "چاپ ناموفق بود!",
    checkoutPrintDataUnavailable: "اطلاعات رسید پرداخت برای چاپ در دسترس نیست",
    printUsingExternalDevice: "چاپ با دستگاه خارجی",
    orderDetails: "جزئیات سفارش",
    noOrders: "سفارشی وجود ندارد",
    noOrdersAdded: "سفارشی اضافه نشده است",
    noAddedItems: "هیچ آیتمی اضافه نشده است",
    loading: "در حال بارگذاری",
    createOrSelectOrderAfterSelectingTable: "ابتدا یک میز انتخاب کنید، سپس سفارش بسازید یا انتخاب کنید",
    createOrSelectOrderFirst: "ابتدا یک سفارش بسازید یا انتخاب کنید",
    customFood: "آیتم سفارشی",
    customFoods: "آیتم‌های سفارشی",
    normalFoodOrDrink: "غذا/نوشیدنی عادی",
    customMenuItems: "آیتم‌های سفارشی منو",
    sentToKitchen: "ارسال‌شده به آشپزخانه",
    sendToKitchen: "ارسال به آشپزخانه",
    orderDelivered: "سفارش تحویل شد",
    orderDeliveredConfirmation: "مطمئن هستید این سفارش تحویل شده است؟",
    selectItemsForSendingToKitchen: "آیتم‌های ارسالی به آشپزخانه را انتخاب کنید",
    type: "نوع",
    status: "وضعیت",
    ItemDetailsAndStatus: "جزئیات / وضعیت آیتم",
    description: "توضیحات",
    typeAnythingYouNeed: "هر چیزی لازم است بنویسید",
    paid: "پرداخت‌شده",
    partiallyPaid: "پرداخت جزئی",
    unpaid: "پرداخت‌نشده",
    pending: "در انتظار",
    canceled: "لغوشده",
    created: "ایجادشده",
    accepted: "پذیرفته‌شده",
    arrival: "رسیده",
    late_arrival: "رسیدن با تاخیر",
    late_pickup: "تحویل با تاخیر",
    request_new_driver: "درخواست راننده جدید",
    shipment_destroyed: "مرسوله آسیب دیده",
    address_not_found: "آدرس پیدا نشد",
    completed: "تکمیل‌شده",
    late_completed: "با تاخیر تکمیل شد",
    isPaid: "پرداخت شده",
    total: "مجموع",
    editOrderItem: "ویرایش آیتم سفارش",
    chooseTable: "انتخاب میز",
    pickup: "تحویل حضوری",
    suspended: "معلق",
    processing: "در حال پردازش",
    rejected: "ردشده",
    delivered: "تحویل‌شده",
    ordersList: "فهرست سفارش‌ها",
    showOlderOrders: "نمایش سفارش‌های قدیمی‌تر",
    showHistory: "نمایش تاریخچه",
    showCanceledOrders: "نمایش سفارش‌های لغوشده",
    showDeliveredOrders: "نمایش سفارش‌های تحویل‌شده",
    showPaidOrders: "نمایش سفارش‌های پرداخت‌شده",
    listOfOrders: "فهرست سفارش‌ها",
    listOfolderOrRejectedOrdersTitle: "قدیمی / ردشده",
    addNewOrder: "افزودن سفارش جدید",
    ordering: "ثبت سفارش",
    availableFoods: "آیتم‌های موجود",
    searchByTableName: "جستجو بر اساس نام میز",
    Layout: "چیدمان",
    gridView: "نمای شبکه‌ای",
    listView: "نمای فهرستی",
    Filters: "فیلترها",
    availableItems: "آیتم‌های موجود",
    searchByFoodName: "جستجو بر اساس نام غذا",
    allCategories: "همه دسته‌بندی‌ها",
    noCategories: "بدون دسته‌بندی",
    addFood: "افزودن آیتم",
    editManualItem: "ویرایش آیتم دستی",
    addManualItem: "افزودن آیتم دستی",
    manualItem: "آیتم دستی",
    manualItems: "آیتم‌های دستی",
    areYouSureYouWantToConvertOrderToDemoModeOrder: "مطمئن هستید می‌خواهید سفارش <1>{{orderId}}</1> را به سفارش دمو تبدیل کنید؟",
    areYouSureYouWantToConvertOrderToLiveModeOrder: "مطمئن هستید می‌خواهید سفارش <1>{{orderId}}</1> را به سفارش زنده تبدیل کنید؟",
    areYouSureYouWantToSwitchToLiveMode: "مطمئن هستید می‌خواهید به حالت زنده برگردید؟",
    areYouSureYouWantToSwitchToDemoMode: "مطمئن هستید می‌خواهید به حالت دمو بروید؟",
    areYouWantDeleteThisItem: "مطمئن هستید می‌خواهید این آیتم را حذف کنید؟",
    areYouWantCancelOrder: "مطمئن هستید می‌خواهید این سفارش را لغو کنید؟",
    getEmailLabel: "لطفاً ایمیل را وارد کنید",
    enterValidEmailErr: "لطفاً یک ایمیل معتبر وارد کنید.",
    sendEmail: "ارسال ایمیل",
    send: "ارسال",
    sendReceiptInfo: "ارسال اطلاعات رسید",
    resendPaymentLink: "ارسال دوباره لینک پرداخت",
    sendMenuSms: "ارسال لینک منو",
    sendMenuLinkBySms: "ارسال لینک منو با پیامک",
    menuLinkSentSuccessfully: "لینک منو با موفقیت ارسال شد",
    paymentLinkResentSuccessfully: "لینک پرداخت با موفقیت ارسال شد",
    receiverEmail: "ایمیل گیرنده",
    receiverPhone: "شماره گیرنده",
    receiverEmailPlaceholder: "example@email.com",
    emailIsRequired: "ایمیل الزامی است",
    phoneNumberIsRequired: "شماره تلفن الزامی است",
    emailOrPhoneIsRequired: "ایمیل یا شماره تلفن الزامی است",
    invalidEmailFormat: "فرمت ایمیل نامعتبر است",
    iUnderstand: "متوجه شدم",
    no: "خیر",
    yes: "بله",
    cancel: "لغو",
    close: "بستن",
    back: "بازگشت",
    next: "بعدی",
    previous: "قبلی",
    add: "افزودن",
    preview: "پیش‌نمایش",
    changeTable: "تغییر میز",
    saveChanges: "ذخیره تغییرات",
    confirm: "تایید",
    unselectAll: "لغو انتخاب همه",
    selectAll: "انتخاب همه",
    selected: "انتخاب‌شده",
    reset: "بازنشانی",
    clear: "پاک کردن",
    mobileKeyboard: "کیبورد موبایل",
    externalDeliveryOrder: "سفارش دلیوری خارجی",
    externalDeliveryOrderDescription: "این سفارش باید قبل از پردازش پذیرفته شود",
    waiterDraftOrder: "سفارش ثبت‌شده توسط گارسون",
    waiterDraftOrderDescription: "هنوز می‌توانید این سفارش را ویرایش کنید. وقتی همه چیز نهایی شد آن را تایید کنید.",
    accept: "پذیرش",
    acceptOrder: "پذیرش سفارش",
    confirmOrder: "تایید سفارش",
    completeOrderSetup: "تکمیل تنظیم سفارش",
    completeOrderSetupDialogTitle: "جزئیات ارسال را کامل کنید و زمان سفارش را نهایی کنید",
    acceptOrderDialogTitle: "با پذیرش این سفارش، آماده‌سازی آغاز می‌شود و آشپزخانه مطلع خواهد شد",
    confirmOrderDialogTitle: "با تایید این سفارش، تغییرات قفل می‌شود و آماده‌سازی شروع می‌شود",
    acceptOrderExternalDescription: "این سفارش از بیرون ثبت شده است. برای شروع آماده‌سازی آن را بپذیرید، یا اگر امکان انجامش را ندارید رد کنید.",
    confirmOrderWaiterCreatedDescription: "این سفارش توسط گارسون ثبت شده است. وقتی همه آیتم‌ها آماده شدند آن را بررسی و تایید کنید.",
    acceptOrderWaiterCreatedDescription: "این سفارش توسط گارسون ثبت شده است. برای قفل شدن تغییرات و شروع آماده‌سازی آن را بپذیرید.",
    editingLockedForCustomerOrder: "ویرایش برای سفارش‌های مشتری قفل است.",
    editingLockedForRejectedOrder: "به‌دلیل رد شدن سفارش، ویرایش قفل است.",
    editingLockedCustomerOrderAfterAcceptance: "پس از پذیرش سفارش مشتری، ویرایش قفل می‌شود.",
    editingLockedAfterConfirmation: "پس از تایید سفارش، ویرایش قفل می‌شود.",
    editingDoneOrderItemLocked: "آیتم‌های تکمیل‌شده دیگر قابل تغییر نیستند.",
    editingPaidOrderItemLocked: "آیتم‌های پرداخت‌شده دیگر قابل تغییر نیستند.",
    editingPendingPaymentOrderItemLocked: "تا وقتی پرداخت این آیتم در حال پردازش است، قابل تغییر نیست.",
    editingSentToKitchenItemLockedByPermission: "اجازه تغییر آیتم‌هایی که به آشپزخانه ارسال شده‌اند را ندارید.",
    rejectOrder: "رد سفارش",
    rejectOrderConfirm: "مطمئن هستید می‌خواهید این سفارش را رد کنید؟",
    acceptOrderPickupTimeHelperText: "می‌توانید زمان تحویل را تا <1>30 دقیقه</1> به تعویق بیندازید",
    pleaseEnterPickupTime: "لطفاً زمان تحویل را وارد کنید",
    addToOrders: "افزودن به سفارش‌ها",
    cancelThisOrder: "لغو این سفارش",
    cancelOrder: "لغو سفارش",
    orderModeChangedToDemoInJSX: "حالت سفارش موردنظر به حالت دمو با عنوان '<1>سفارش {{targetOrderId}}</1>' تغییر کرد.",
    orderModeChangedToLiveInJSX: "حالت سفارش موردنظر به حالت زنده با عنوان '<1>سفارش {{targetOrderId}}</1>' تغییر کرد.",
    checkoutHasPaidByPosInJSX: "<1>تسویه</1> با شناسه <3>{{checkout_id}}</3> از <5>سفارش {{order_id}}</5> با موفقیت از طریق POS پرداخت شد.",
    demo: "دمو",
    demoModeIsActive: "حالت دمو فعال است",
    demoModeAlertMessage: "حالت آزمایشی (دمو) فقط برای اهداف آموزشی و آزمایشی در نظر گرفته شده است. مسئولیت استفاده از سیستم و رعایت کلیه مقررات قانونی مربوطه در هنگام فعال بودن حالت آزمایشی، بر عهده اپراتور رستوران است.",
    normal: "عادی",
    showOrderInTargetMode: "نمایش سفارش در حالت {{targetMode}}",
    showOrder: "نمایش سفارش",
    openOrderInBackground: "<0>باز کردن</0> <1>(در پس‌زمینه)</1>",
    incomingOrderNotificationTitle: "سفارش جدید دریافت شد",
    incomingOrderNotificationDescription: "یک سفارش مشتری رسیده است. با دکمه زیر آن را بدون بستن این پنجره در پس‌زمینه باز کنید.",
    yesDeleteIt: "بله، حذف شود",
    pay: "پرداخت",
    payment: "پرداخت",
    payments: "پرداخت‌ها",
    payReport: "گزارش پرداخت",
    paymentOf: "پرداختِ",
    checkoutOperation: "عملیات تسویه",
    itemsToPay: "آیتم‌های قابل پرداخت",
    price: "قیمت",
    basicPrice: "قیمت پایه",
    totalPrice: "قیمت کل",
    baseAmount: "مبلغ پایه",
    paidPrice: "مبلغ پرداخت‌شده",
    paidBy: "پرداخت توسط",
    discount: "تخفیف",
    discountAmount: "مبلغ تخفیف",
    tipPrice: "مبلغ انعام",
    totalWithTip: "جمع با انعام",
    amountToPay: "مبلغ قابل پرداخت",
    paymentAmount: "مبلغ پرداخت",
    paymentsIncludingDiscounts: "پرداخت‌ها با احتساب تخفیف",
    paymentsExcludingDiscounts: "پرداخت‌ها بدون احتساب تخفیف",
    paymentsTakingIntoAccountTheirDiscount: "پرداخت‌ها با درنظر گرفتن تخفیف",
    paymentsRegardlessOfTheirDiscount: "پرداخت‌ها بدون توجه به تخفیف",
    openPaymentsStatistics: "آمار پرداخت‌های باز",
    discountCannotBeLessThanZero: 'مبلغ تخفیف نمی‌تواند کمتر از "0" باشد',
    discountCannotBeNegative: "مبلغ تخفیف نمی‌تواند منفی باشد",
    discountCannotBeMoreThanHundredPercent: 'مبلغ تخفیف نمی‌تواند بیشتر از "100%" باشد',
    discountCannotBeMoreThan: "مبلغ تخفیف نمی‌تواند بیشتر از {{price}} باشد",
    theValueMustBeMoreThan: "مقدار باید بیشتر از {{price}} باشد",
    theValueMustBeMoreThanBaseAmount: "مقدار باید بیشتر از مبلغ پایه باشد",
    valueMustBeLessThanOrEqualToMessage: "مقدار باید کمتر یا مساوی {{maxPrice}} باشد",
    valueMustBeGreaterThanZeroMessage: "مقدار باید بیشتر از 0 باشد",
    tip: "انعام",
    tipAmount: "مبلغ انعام",
    tipCannotBeNegative: "مبلغ انعام نمی‌تواند منفی باشد",
    payByCreditCard: "پرداخت با کارت اعتباری",
    payInCash: "پرداخت نقدی",
    cardTransfer: "انتقال کارت",
    checkout: "تسویه",
    transaction: "تراکنش",
    noTransactionHasBeenMade: "هیچ تراکنشی انجام نشده است",
    backToTransactionsList: "بازگشت به فهرست تراکنش‌ها",
    transactionsHistory: "تاریخچه تراکنش‌ها",
    transactionDetails: "جزئیات تراکنش",
    transactionId: "شناسه تراکنش",
    transactionHasBeenSentToYourEmail: "تراکنش به ایمیل شما ارسال شد",
    paymentType: "نوع پرداخت",
    paymentStatus: "وضعیت پرداخت",
    ordersPrice: "مبلغ سفارش‌ها",
    totalAmount: "مبلغ کل",
    updatedAt: "به‌روزرسانی در",
    fromTime: "از ساعت",
    toTime: "تا ساعت",
    backToOrders: "بازگشت به سفارش‌ها",
    tablesList: "فهرست میزها",
    backToTablesList: "بازگشت به فهرست میزها",
    showDetails: "نمایش جزئیات",
    receiptDetailsPage: "صفحه جزئیات رسید",
    checkoutQrCodeAlt: "کد QR تسویه",
    vat: "مالیات بر ارزش افزوده",
    net: "خالص",
    tax: "مالیات",
    gross: "ناخالص",
    sendingEmailFailed: "ارسال ایمیل ناموفق بود!",
    paymentFailed: "پرداخت ناموفق بود",
    openPayments: "پرداخت‌های باز",
    Open_Payments: "پرداخت‌های باز",
    openPaymentsReport: "گزارش پرداخت‌های باز",
    report: "گزارش",
    openPaymentStatistics: "آمار پرداخت باز",
    allOrderItemsHaveBeenPaid: "همه آیتم‌های این سفارش پرداخت شده‌اند",
    noItemsHaveBeenAddedInThisOrder: "هیچ آیتمی به این سفارش اضافه نشده است",
    thisItemPaymentIsAwaitingConfirmation: "پرداخت این آیتم در انتظار تایید است",
    yourOrderPaymentIsAwaitingConfirmation: "یک پرداخت برای این سفارش در انتظار تایید است",
    editableInTime: "قابل ویرایش در {{minutes}}د {{seconds}}ث",
    thisItemHasBeenPaidThroughPOSAndIsAwaitingPaymentConfirmation: "این آیتم از طریق POS پرداخت شده و در انتظار تایید پرداخت است",
    yourOrderHasBeenPaidThroughPOSAndIsAwaitingPaymentConfirmation: "این سفارش از طریق POS پرداخت شده و در انتظار تایید پرداخت است",
    generalSettings: "تنظیمات عمومی",
    customItems: "آیتم‌های سفارشی",
    printMethod: "روش چاپ",
    singlePrintMethodDescription: "در هر لحظه فقط یک روش چاپ فعال است",
    printMethodBrowser: "پنجره چاپ مرورگر",
    printMethodBluetooth: "چاپگر بلوتوث",
    printMethodUsb: "چاپگر USB (آزمایشی)",
    printMethodExternal: "چاپگر / اپ خارجی",
    bluetoothUnavailable: "بلوتوث در این مرورگر یا دستگاه در دسترس نیست",
    bluetoothSecureContextRequired: "چاپ بلوتوث به HTTPS یا localhost نیاز دارد",
    bluetoothPrinterNotSupported: "چاپگر بلوتوث انتخاب‌شده پشتیبانی نمی‌شود",
    noBluetoothPrinterSelected: "هیچ چاپگر بلوتوثی انتخاب نشده است",
    noCompatibleBluetoothPrinterFound: "هیچ چاپگر بلوتوث سازگار پیدا یا انتخاب نشد. مرورگرها معمولاً فقط چاپگرهای BLE/GATT را پیدا می‌کنند و مدل‌های کلاسیک مثل Epson TM-m30 ممکن است اینجا نمایش داده نشوند",
    bluetoothAutoPrintRequiresSelection: "برای فعال شدن چاپ خودکار، یک‌بار چاپگر بلوتوث را به‌صورت دستی انتخاب کنید",
    bluetoothPrintingNotSupported: "چاپ بلوتوث در این مرورگر یا دستگاه پشتیبانی نمی‌شود",
    usbUnavailable: "USB در این مرورگر یا دستگاه در دسترس نیست",
    usbSecureContextRequired: "چاپ USB به HTTPS یا localhost نیاز دارد",
    noCompatibleUsbPrinterFound: "هیچ چاپگر USB سازگار پیدا یا انتخاب نشد",
    usbAccessDenied: "مرورگر یا سیستم‌عامل دسترسی به چاپگر USB انتخاب‌شده را رد کرد. برنامه‌های دیگر چاپگر را ببندید و مجوزهای USB سیستم را بررسی کنید، سپس دوباره تلاش کنید",
    usbAutoPrintRequiresSelection: "برای استفاده از چاپ خودکار، یک‌بار چاپگر USB را به‌صورت دستی انتخاب کنید",
    usbPrintingNotSupported: "چاپ USB برای دستگاه انتخاب‌شده پشتیبانی نمی‌شود",
    printerSize: "اندازه چاپگر",
    useExternalPrinter: "استفاده از چاپگر خارجی",
    bluetoothPrinterDetails: "می‌توانید چاپ را به دستگاه‌های چاپگر بلوتوث بفرستید، یا این گزینه را غیرفعال کنید تا از میان چاپگرهای متصل به این دستگاه یکی را انتخاب کنید",
    usbPrinterDetails: "پشتیبانی آزمایشی برای چاپگرهای USB سازگار با ESC/POS در Chrome یا Edge دسکتاپ. ممکن است لازم باشد یک‌بار چاپگر را دستی انتخاب کنید تا چاپ خودکار از آن استفاده کند. در ویندوز ممکن است چاپگر به Vendor Class mode و درایور سازگار با WinUSB هم نیاز داشته باشد تا در فهرست مرورگر دیده شود",
    externalPrinterDetails: "می‌توانید چاپ را به چاپگرهای خارجی متصل به برنامه ارسال کنید، یا این گزینه را غیرفعال کنید تا از میان چاپگرهای متصل به این دستگاه یکی را انتخاب کنید",
    autoPrint: "چاپ خودکار",
    autoPrintDescription: "پس از پذیرش سفارش یا دریافت رویداد وب‌سوکتِ پرداخت سفارش، به‌طور خودکار چاپ کن",
    autoPrintUnavailableForBrowserDescription: "در حالت پنجره چاپ مرورگر، چاپ خودکار در دسترس نیست",
    browserPrintMethodNotice: "پنجره چاپ مرورگر همیشه نیاز به تایید دارد، بنابراین رسیدها خودکار چاپ نمی‌شوند",
    selectAllPayablesByDefault: "انتخاب خودکار همه موارد قابل پرداخت",
    selectAllPayablesByDefaultOnThePaymentPage: "در صفحه پرداخت، همه موارد قابل پرداخت به‌صورت پیش‌فرض انتخاب شوند",
    virtualKeyboard: "کیبورد مجازی",
    virtualKeyboardDescription: "استفاده از کیبورد داخلی برنامه در فیلدهای پشتیبانی‌شده",
    virtualKeyboardInfoLabel: "راهنمای کیبورد",
    virtualKeyboardDisableHint: "اگر ترجیح می‌دهید از کیبورد دستگاه استفاده کنید، می‌توانید این کیبورد را از <0>تنظیمات</0> خاموش کنید.",
    delivery: "ارسال",
    deliveryAddress: "آدرس ارسال",
    deliveryDetails: "جزئیات ارسال",
    addDeliveryDetails: "افزودن جزئیات ارسال",
    editDeliveryDetails: "ویرایش جزئیات ارسال",
    createDelivery: "ایجاد ارسال",
    fullAddress: "آدرس کامل",
    postalCode: "کد پستی",
    houseNumber: "پلاک",
    served: "سرو شد",
    doorNumber: "شماره در",
    apartmentEntrance: "ورودی واحد",
    floor: "طبقه",
    extraAddressDetails: "جزئیات تکمیلی آدرس",
    fullName: "نام کامل",
    dialCode: "کد کشور",
    phoneNumber: "شماره تلفن",
    contactInformationAtPickup: "اطلاعات تماس گیرنده",
    recommended: "پیشنهادی",
    deliverySummary: "خلاصه ارسال",
    Error: "خطا",
    unexpectedErrorOccurred: "خطایی رخ داده است",
    distance: "فاصله",
    duration: "مدت زمان",
    minutes: "دقیقه",
    deliveryPrice: "هزینه ارسال",
    deliveryFee: "کارمزد ارسال",
    itemsPrice: "مبلغ آیتم‌ها",
    totalReceipt: "جمع رسید",
    successfulDeliveryRegistration: "ثبت ارسال با موفقیت انجام شد",
    successfulSendDelivery: "ارسال با موفقیت انجام شد",
    customer: "مشتری",
    withDelivery: "با ارسال",
    deliveryItem: "آیتم ارسالی",
    pickupDetails: "جزئیات تحویل حضوری",
    pickupDate: "تاریخ تحویل",
    pickupTime: "زمان تحویل",
    pickupDatetime: "تاریخ/زمان درخواست‌شده برای تحویل",
    pickupTimeLabel: "زمان تحویل ({{format}})",
    pickupTimeBaseLabel: "زمان پایه تحویل",
    pickupTimeFinalLabel: "زمان نهایی تحویل",
    dropOffTime: "زمان رساندن",
    requestedPickupDatetime: "تاریخ/زمان فعلیِ درخواست‌شده برای تحویل",
    timePickerHour: "ساعت",
    timePickerMinute: "دقیقه",
    toggleTimeList: "نمایش/عدم نمایش فهرست زمان‌ها",
    pickupTimeInitialShort: "پایه",
    orderTiming: "زمان‌بندی سفارش",
    maximumSelectableFreeCountHint: "حداکثر تعداد قابل انتخاب به‌صورت رایگان",
    minimumSelectableCountHint: "حداقل تعداد قابل انتخاب",
    maximumSelectableCountHint: "حداکثر تعداد قابل انتخاب",
    maximumSelectedItemsReached: "تعداد آیتم‌های انتخاب‌شده به حداکثر رسیده است",
    changePickupTime: "تغییر زمان تحویل",
    pickupTimeAllowedRangeHint: "برای {{date}}، زمان تحویل را می‌توان بین {{start}} تا {{end}} انتخاب کرد.",
    pickupDatetimeNotSetHint: "هنوز تاریخ/زمان تحویل تنظیم نشده است. می‌توانید هر زمان تحویلی را انتخاب کنید.",
    pickupDatetimeLimitedDelayHint: "این تاریخ/زمان درخواست‌شده تا زمانی که سفارش هنوز در انتظار پذیرش است، حداکثر تا <1>30 دقیقه</1> قابل تاخیر است.",
    pickupDatetimeLockedHint: "برای این سفارش قبلاً تاریخ/زمان تحویل تنظیم شده است.",
    pickupTimeEditableOnlyWhenSuspended: "زمان تحویل فقط زمانی قابل تغییر است که سفارش در وضعیت معلق باشد.",
    pleaseEnterPickupDate: "لطفاً تاریخ تحویل را وارد کنید",
    pickupDateMustBeTodayOrTomorrow: "برای سفارش‌های ثبت‌شده توسط گارسون، تاریخ تحویل باید امروز یا فردا باشد.",
    normalOrderCreationUnavailableTitle: "سفارش‌های عادی در حال حاضر در دسترس نیستند",
    normalOrderCreationClosedAllDay: "رستوران در این روز بسته است، بنابراین امکان ایجاد سفارش وجود ندارد.",
    normalOrderCreationClosedAtThisTime: "رستوران در حال حاضر بسته است. ایجاد سفارش در ساعات کاری ممکن است: {{hours}}.",
    waiterOrderNoAvailableOpenSlot: "در تاریخ‌های مجاز فعلی، هیچ زمان معتبر {{orderType}} در ساعات کاری رستوران موجود نیست.",
    pickupDateOutsideOpeningHours: "تاریخ انتخاب‌شده خارج از روزهای مجاز برای سفارش‌های {{orderType}} است.",
    pickupTimeOutsideOpeningHours: "زمان انتخاب‌شده خارج از ساعات مجاز برای سفارش‌های {{orderType}} است.",
    openingHoursSelectableRangeHint: "برای {{date}}، زمان {{orderType}} را می‌توان بین {{start}} تا {{end}} انتخاب کرد.",
    openingHoursClosedDayHint: "{{date}} برای سفارش‌های {{orderType}} بسته است.",
    openingHoursClosedDayCalendarHint: "برای این نوع سفارش بسته است",
    openingHoursDisabledDatesHint: "فقط تاریخ‌هایی قابل انتخاب‌اند که در ساعات کاری رستوران حداقل یک زمان قابل انتخاب برای سفارش‌های {{orderType}} داشته باشند.",
    openingHoursUnavailableTimesHint: "ساعت‌هایی که قابل انتخاب نیستند، در تاریخ انتخاب‌شده خارج از ساعات کاری رستوران برای سفارش‌های {{orderType}} هستند.",
    deliveryAndPickupOrders: "سفارش‌های ارسال و تحویل حضوری",
    orderId: "شناسه سفارش",
    orderStatus: "وضعیت سفارش",
    waiter: "گارسون",
    fromCustomerApp: "از اپ مشتری",
    orderType: "نوع سفارش",
    payByLink: "پرداخت با لینک",
    sendDelivery: "ارسال سفارش",
    updateDelivery: "به‌روزرسانی ارسال",
    requestCourier: "درخواست پیک",
    sendCourierRequest: "ارسال درخواست پیک",
    sentToCourier: "برای پیک ارسال شد",
    callCourier: "تماس با پیک",
    somethingWentWrong: "مشکلی پیش آمد",
    noPickupTimeProvidedForThisOrder: "برای این سفارش زمان تحویل ثبت نشده است",
    pickupTimeCalculationForThisOrderFailed: "محاسبه زمان تحویل برای این سفارش ناموفق بود",
    itemEditFailed: "ویرایش آیتم ناموفق بود",
    thisItemCannotBeEdited: "این آیتم قابل ویرایش نیست.",
    problemInReadingItemEssentialDataMessage: "در خواندن اطلاعات ضروری آیتم مشکلی پیش آمد",
};

export default fa;
